/**
 * 活动相关api
 *
 * @param http
 * @returns {{pushError2DingTalk(*): *, modifyPassword(*): *, queryAll(*): *}|*}
 */
export default (http) => {
    return {
        queryByPage (data){
            return http.json({
                url: '/activity/queryPage',
                data
            })
        },

        list (data){
            return http.json({
                url: '/activity/backList',
                data
            })
        },
        /**
         * 保存信息
         * @param data
         * @returns {*}
         */
        saveInfo(data) {
            return http.json({
                url: '/activity/saveInfo',
                data
            })
        },
        /**
         * 获取详情
         * @param data
         * @return {*}
         */
        getInfo(data) {
            return http.get(
                `/activity/getInfo?id=${data.id}`
            )
        },
        queryList (data){
            return http.json({
                url: '/activity/queryList',
                data
            })
        },
        queryActivityList (data){
            return http.json({
                url: '/activity/queryActivityList',
                data
            })
        },

        /**
         * 删除
         * @param data
         * @returns {*}
         */
        removeInfo(data) {
            return http.get(
                `/activity/deleteById?id=${data}`,
            )
        },


        pushError2DingTalk (data){
            return http.json({
                baseURL: '/push2DingTalk',
                url: '/robot/send?access_token=759cad39341a498a78ce498609640e09b771c7342da428dbbb15602702d4f85a',
                data
            });
        },
        /**
         * 隐藏或显示活动
         * @param data
         * @return {*}
         */
        showOrHidden(data) {
            return http.get(
                `/activity/showOrHidden?id=${data.id}&state=${data.state}`
            )
        },

        getVillageList(){
            return http.get(
                `/activity/getVillageList`
            )
        },
        queryProperty(){
            return http.get(
                `/activity/queryProperty`
            )
        },
        examine(data){
            return http.json({
                url: '/activity/examine',
                data
            })
        },
        bindPaper(data){
            return http.json({
                url: '/activity/bindPaper',
                data
            })
        },

    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/activity.js